import InputHeader from "../input/InputHeader";
import { useContext } from "react";
import AuthContext from "../../context/AuthContext";
import InputCard from "../containers/InputCard";
import InfoLabel from "./InfoLabel";

const CurrentUser = () => {
  const authCtx = useContext(AuthContext);

  return (
    <InputCard>
      <InputHeader text="Audit Conducted By" />
      <InfoLabel identifier="currentUser" text={authCtx?.user?.displayName} />
    </InputCard>
  );
};

export default CurrentUser;
